export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const EXECUTE_SUBSCRIPTION_ACTION = 'EXECUTE_SUBSCRIPTION_ACTION';
export const REDUCE_ENTITY_SUBSCRITION = 'REDUCE_ENTITY_SUBSCRITION';
export const REDUCE_SUBSCRIPTION = 'REDUCE_SUBSCRIPTION';
export const REDUCE_SUBSCRIPTION_ELEMENT = 'REDUCE_SUBSCRIPTION_ELEMENT';
export const REDUCE_SUBSCRIPTIONS = 'REDUCE_SUBSCRIPTIONS';
